<template>
  <b-modal
    centered
    hide-header
    hide-footer
    ref="account-modal"
    v-model="showEditor"
    title="Edit Profile"
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
    dialog-class="custom-modal-profile"
    @show="initializeTopazPad"
    @hide="disconectSigWeb"
  >
    <image-cropper
      :image="fileChoosed"
      v-model="cropImage"
      @cropped="saveCroppedImage"
    />
    <div class="d-flex flex-column align-items-center mb-2">
      <h4 class="mb-4 mt-3">My Account</h4>
      <div
        class="picture-preview text-center"
        style="width: 165px; height: 165px;"
      >
        <img
          :src="
            form.avatar
              ? form.avatar
              : require(`../../assets/avatar-example.png`)
          "
        />
      </div>
      <b-form-group
        :state="formErrors.avatar.length == 0 ? null : false"
        :invalid-feedback="formErrors.avatar.join(', ')"
      >
        <input
          ref="fileUpload"
          @change="cropFile"
          type="file"
          accept="image/*"
          hidden
        />
      </b-form-group>
      <label class="mb-0 text-primary fileUploadLb" @click="chooseFile()"
        >Choose file</label
      >

      <b-container class="mt-4">
        <b-row>
          <b-col>
            <b-form-group
              class="custom-form-group"
              label="First Name"
              :state="formErrors.firstName.length == 0 ? null : false"
              :invalid-feedback="formErrors.firstName.join(', ')"
            >
              <template v-slot:label>
                First Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.firstName"
                trim
                maxLength="50"
                :state="formErrors.firstName.length == 0 ? null : false"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Middle Name" class="custom-form-group">
              <b-form-input
                v-model="form.middleName"
                trim
                maxLength="50"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="custom-form-group"
              label="Last Name"
              :state="formErrors.lastName.length == 0 ? null : false"
              :invalid-feedback="formErrors.lastName.join(', ')"
            >
              <template v-slot:label>
                Last Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.lastName"
                trim
                maxLength="50"
                :state="formErrors.lastName.length == 0 ? null : false"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Credentials" class="custom-form-group">
              <b-form-select
                :disabled="!this.currentUser.providerInfo"
                v-model="form.credentialId"
                :options="credentials"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              class="custom-form-group"
              label="Email"
              :state="formErrors.email.length == 0 ? null : false"
              :invalid-feedback="formErrors.email.join(', ')"
            >
              <template v-slot:label>
                Email <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.email"
                trim
                maxLength="200"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="custom-form-group"
              label="Mobile Phone"
              :state="formErrors.phone.length == 0 ? null : false"
              :invalid-feedback="formErrors.phone.join(', ')"
            >
              <phone-input
                ref="phoneInput"
                defaultCountry="US"
                v-model="form.phone"
                trim
                :state="formErrors.phone.length == 0 ? null : false"
              ></phone-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>

      <b-container>
        <h6 class="mt-4 mb-3 pl-2">Notifications</h6>
        <b-row>
          <b-col>
            <b-form-group class="custom-form-group">
              <div class="d-flex align-items-center">
                <vue-toggles
                  @click="changeReceiveSMS()"
                  :value="form.receiveSms"
                  height="30"
                  width="50"
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                  class="mr-2"
                />
                <span class="mr-2">Receive messages via SMS</span>
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="mt-2 custom-form-group">
              <div class="d-flex align-items-center">
                <vue-toggles
                  @click="changeReceiveEmail()"
                  :value="form.receiveEmail"
                  height="30"
                  width="50"
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                  class="mr-2"
                />
                <span class="mr-2">Receive messages via Email</span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <h5 class="mt-4 mb-3">My Signature <span class="text-danger">*</span></h5>
      <b-form-group
        style="width:466px;"
        v-if="isTopazIntalled && !settedSignature"
        label="Mode"
      >
        <b-form-radio-group v-model="padType">
          <b-row>
            <b-col>
              <b-form-radio value="topaz">Topaz</b-form-radio>
            </b-col>
            <b-col>
              <b-form-radio value="mouse">Mouse</b-form-radio>
            </b-col>
          </b-row>
        </b-form-radio-group>
      </b-form-group>
      <div class="d-flex flex-row justify-content-center">
        <div>
          <b-form-group
            v-if="settedSignature"
            label=""
            :state="formErrors.lastName.length == 0 ? null : false"
            :invalid-feedback="formErrors.lastName.join(', ')"
          >
            <img width="466" height="150" :src="currentUser.signature" />
          </b-form-group>
          <div v-show="!settedSignature">
            <VueSignaturePad
              class="border mx-auto"
              width="466px"
              height="150px"
              ref="signaturePad"
              :style="{ display: padType == 'mouse' ? 'block' : 'none' }"
            />
            <canvas
              :style="{ display: padType == 'topaz' ? 'block' : 'none' }"
              class="border mx-auto"
              ref="topaz-canvas"
              width="466"
              height="150"
            />
          </div>
          <span v-if="formErrors.imgData.length != 0" class="text-danger"
            >The signature is required</span
          >
          <div class="d-flex flex-row justify-content-end mt-1">
            <a href="#" @click="clearSignature">Clear All</a>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <b-button
          class="mr-3"
          v-if="dismissable"
          variant="secondary"
          @click="close"
          style="width: 7rem"
        >
          Close
        </b-button>
        <b-button variant="success" @click="submitProfile" style="width: 7rem">
          Save
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import userServer from "../../server/user";

import {
  validateRequired,
  validateEmail,
  validatePhoneNumber
} from "../../helpers/validation";
import { resizeImage } from "../../helpers/file";
import ImageCropper from "../controls/ImageCropper.vue";
import PhoneInput from "../controls/PhoneInput.vue";

let tabletState = null;

export default {
  name: "MyAccountModal",
  components: { ImageCropper, PhoneInput },
  props: ["value", "dismissable"],
  data() {
    return {
      form: {
        avatar: "",
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        credentialId: "",
        imgData: "",
        imgEmpty: "",
        receiveEmail: true,
        receiveSms: true
      },
      formErrors: {
        avatar: [],
        firstName: [],
        middleName: [],
        lastName: [],
        email: [],
        phone: [],
        imgData: []
      },
      fileChoosed: null,
      cropImage: false,
      settedSignature: false,
      padType: "mouse"
    };
  },
  mounted() {
    this.fetchCurrentUser();
    this.setInitialValues();
    this.fetchCredentials();
    this.settedSignature = this.currentUser.signature != null;
    this.editorShown = true;
    setTimeout(() => {
      this.$refs.signaturePad.resizeCanvas();
    }, 250);
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "fetchCurrentUser"]),
    ...mapActions("layout", ["fetchCredentials"]),
    submitProfile: async function(modalEvent) {
      modalEvent.preventDefault();
      if (this.validateProfile() === false) {
        return;
      }
      if (this.padType == "topaz") {
        window.SetSigCompressionMode(1);
        window.GetSigString();
        let signatureCanvas = this.$refs["topaz-canvas"];
        let canvasContext = signatureCanvas.getContext("2d");
        this.form.imgData = signatureCanvas.toDataURL();
        canvasContext.clearRect(
          0,
          0,
          signatureCanvas.width,
          signatureCanvas.height
        );

        window.SetDisplayXSize(500);
        window.SetDisplayYSize(100);
        window.SetTabletState(0, tabletState);
        window.SetJustifyMode(0);
        window.ClearTablet();
        tabletState =
          window.SetTabletState(1, canvasContext, 50) || tabletState;
      } else {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        this.form.imgData = data;
        this.form.imgEmpty = isEmpty;
      }
      await userServer.updateCurrentUserProfile({
        firstName: this.form.firstName,
        middleName: this.form.middleName,
        lastName: this.form.lastName,
        email: this.form.email,
        phone:
          this.form.phone.trim().length > this.activeCountry.dialCode.length + 1
            ? this.form.phone
            : "",
        credentialId: this.form.credentialId,
        avatarContent: this.fileChoosed ? this.form.avatar : null,
        signatureData: this.settedSignature ? null : this.form.imgData,
        receiveEmail: this.form.receiveEmail,
        receiveSms: this.form.receiveSms
      });
      this.disconectSigWeb();
      this.showEditor = false;
      this.fetchCurrentUser();
      this.showAlertSuccess();
    },
    changeReceiveEmail() {
      this.form.receiveEmail = !this.form.receiveEmail;
    },
    changeReceiveSMS() {
      this.form.receiveSms = !this.form.receiveSms;
    },
    validateProfile: function() {
      let withoutErrors = true;
      this.clearStateErrors();

      if (!validateRequired(this.form.firstName)) {
        this.formErrors.firstName.push("This field is required");
        withoutErrors = false;
      }

      if (!validateRequired(this.form.lastName)) {
        this.formErrors.lastName.push("This field is required");
        withoutErrors = false;
      }

      if (!validateRequired(this.form.email)) {
        this.formErrors.email.push("This field is required");
        withoutErrors = false;
      } else if (!validateEmail(this.form.email)) {
        this.formErrors.email.push("This field must have a valid email format");
        withoutErrors = false;
      }

      this.formErrors.phone = [];
      if (
        this.form.phone.trim().length >
          this.activeCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.phone)
      ) {
        this.formErrors.phone.push("Invalid phone number");
        withoutErrors = false;
      }

      if (!this.settedSignature) {
        let signatureEmpty = false;
        if (this.padType == "mouse") {
          const { isEmpty } = this.$refs.signaturePad.saveSignature();
          signatureEmpty = isEmpty;
        } else {
          let signatureCanvas = this.$refs["topaz-canvas"];
          const context = signatureCanvas.getContext("2d");

          const pixelBuffer = new Uint32Array(
            context.getImageData(
              0,
              0,
              signatureCanvas.width,
              signatureCanvas.height
            ).data.buffer
          );

          signatureEmpty = !pixelBuffer.some(color => color !== 0);
        }
        if (signatureEmpty) {
          this.formErrors.imgData.push("The signature is required");
          withoutErrors = false;
        }
      }
      return withoutErrors;
    },
    chooseFile: function() {
      this.$refs.fileUpload.click();
    },
    cropFile: async function() {
      const file = this.$refs.fileUpload.files[0];
      const result = this.validateCropFile(file);
      if (result) {
        const blobUrl = URL.createObjectURL(file);
        const blob = await resizeImage(blobUrl, 1920, 1920);
        this.fileChoosed = blob;
        this.cropImage = true;
      }
    },
    validateCropFile: function(file) {
      let withoutErrors = true;

      const fileSize = (file.size / 1024 / 1024).toFixed(4);

      this.formErrors.avatar = [];
      if (fileSize > 20) {
        this.formErrors.avatar.push("Image max size 20 mb");
        withoutErrors = false;
      }

      if (!file.type.includes("image/")) {
        this.formErrors.avatar.push("Only image file supported");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    saveCroppedImage: function(croppedBase64) {
      this.form.avatar = croppedBase64;
    },
    setInitialValues: function() {
      this.form = {
        firstName: this.currentUser.firstName,
        middleName: this.currentUser.middleName,
        lastName: this.currentUser.lastName,
        email: this.currentUser.email,
        phone: this.currentUser.phone,
        avatar: this.currentUser.avatar,
        credentialId: this.currentUser.credentialId,
        receiveEmail: this.currentUser.receiveEmail,
        receiveSms: this.currentUser.receiveSms
      };

      this.clearStateErrors();
    },
    clearStateErrors: function() {
      this.formErrors.firstName = [];
      this.formErrors.middleName = [];
      this.formErrors.lastName = [];
      this.formErrors.email = [];
      this.formErrors.ImgData = [];
    },
    async sigImageCallback(data) {
      await userServer.updateCurrentUserProfile({
        signatureData: `data:image/png;base64,${data}`
      });
      this.disconectSigWeb();
      this.editorShown = false;
      this.fetchCurrentUser();
    },
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      }
      if (this.isTopazIntalled) {
        window.ClearTablet();
      }
      this.settedSignature = false;
    },
    initializeTopazPad() {
      const self = this;
      setTimeout(() => {
        try {
          self.padType = self.isTopazIntalled ? "topaz" : "mouse";
          if (self.isTopazIntalled) {
            let signatureCanvas = self.$refs["topaz-canvas"];
            let canvasContext = signatureCanvas.getContext("2d");
            canvasContext.clearRect(
              0,
              0,
              signatureCanvas.width,
              signatureCanvas.height
            );
            window.SetDisplayXSize(500);
            window.SetDisplayYSize(100);
            window.SetTabletState(0, tabletState);
            window.SetJustifyMode(0);
            window.ClearTablet();
            tabletState =
              window.SetTabletState(1, canvasContext, 50) || tabletState;
          }
        } catch (e) {
          self.isTopazIntalled = false;
          // If exception throws, means the current machine doesn't have the SignaturePad driver.
        }
      }, 250);
    },
    disconectSigWeb() {
      if (this.isTopazIntalled) {
        window.ClearTablet();
        window.SetTabletState(0, tabletState);
        clearInterval(tabletState);
      }
    },
    close() {
      this.showEditor = false;
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      isTopazIntalled: state => state.isTopazIntalled,
      credentials: state =>
        state.credentials.map(credential => ({
          value: credential.id,
          text: credential.name
        }))
    }),
    showEditor: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.disconectSigWeb();
        }
        this.$emit("input", value);
      }
    },
    activeCountry() {
      return this.$refs.phoneInput.$refs.telInput.activeCountry;
    }
  },
  watch: {
    value: function(newValue) {
      if (newValue) {
        this.setInitialValues();
      }
    },
    padType: function(newValue) {
      if (newValue == "mouse") {
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      }
    }
  }
};
</script>
<style scoped>
.custom-form-group {
  margin: 4px 20px 4px 7px;
}

div >>> .custom-modal-profile {
  max-width: 800px;
}
</style>
